export default {
  headers: [
    ['satellite-tracking/report.date', 'day'],
    ['satellite-tracking/report.drivers', 'drivers'],
    ['satellite-tracking/report.business_drive_distance', 'business_distance'],
    ['satellite-tracking/report.business_drive_time', 'business_duration'],
    ['satellite-tracking/report.private_drive_distance', 'private_distance'],
    ['satellite-tracking/report.private_drive_time', 'private_duration'],
    ['satellite-tracking/report.total_distance_for_day', 'total_distance']
  ]
}
